import { render, staticRenderFns } from "./NotificationCreate.vue?vue&type=template&id=33c674fa&scoped=true&"
import script from "./NotificationCreate.vue?vue&type=script&lang=js&"
export * from "./NotificationCreate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCreate.vue?vue&type=style&index=0&id=33c674fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c674fa",
  null
  
)

export default component.exports